var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8754 11.5527C21.8754 10.8587 21.8125 10.1999 21.7048 9.55859H11.5625V13.5205H17.3696C17.1094 14.8207 16.3464 15.9188 15.2155 16.6655V19.3009H18.6801C20.7085 17.4649 21.8754 14.7592 21.8754 11.5527Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.562 21.8562C14.47 21.8562 16.9024 20.9074 18.6796 19.2998L15.215 16.6644C14.2457 17.2969 13.016 17.6834 11.562 17.6834C8.75265 17.6834 6.37414 15.8298 5.52147 13.3262H1.94922V16.0407C3.71739 19.4843 7.35247 21.8562 11.562 21.8562Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52111 13.3278C5.29672 12.6953 5.18004 12.0188 5.18004 11.316C5.18004 10.6133 5.3057 9.93684 5.52111 9.30434V6.58984H1.94885C1.21286 8.01298 0.791016 9.6118 0.791016 11.316C0.791016 13.0203 1.21286 14.6191 1.94885 16.0423L5.52111 13.3278Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.562 4.9462C13.1506 4.9462 14.5688 5.48208 15.6907 6.52747L18.7603 3.52307C16.9024 1.81883 14.47 0.773438 11.562 0.773438C7.35247 0.773438 3.71739 3.14533 1.94922 6.58896L5.52147 9.30345C6.37414 6.79979 8.75265 4.9462 11.562 4.9462Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.bd0726db51acdad6de58a8aaff94a987.svg";
export { ForwardRef as ReactComponent };